import React, { useEffect, useState } from 'react'
import Layout from '../../components/layout/layout'
import {
  Box,
  Button,
  Columns,
  Container,
  Form,
  Heading,
  Icon,
  Section,
} from 'react-bulma-components'
import { ClipboardCopyIcon } from '@heroicons/react/solid'
import { CheckIcon } from 'src/components/icons'

export const HelpPage: React.FC = () => {
  const [copy, setCopy] = useState(false)

  useEffect(() => {
    if (copy === true) {
      navigator.clipboard.writeText('support@team-tim.fr')
    }
  }, [copy])

  return (
    <Layout>
      <Section size="medium">
        <Container max={true} breakpoint={'desktop'} textAlign={'center'}>
          <Heading textColor="primary">Un problème avec TeamTim ?</Heading>
          Notre support répond dans les meilleurs délais à vos demandes et questions.
          <br />
          TeamTim est une plateforme vivante, qui s'améliore chaque jour.
          <br />
          Tout retour de nos utilisateurs est précieux.
          <br /> <br /> <br />
          <Box pb={5}>
            Vous pouvez nous contacter via
            <br /> <br />
            <Columns centered>
              <Columns.Column narrow>
                <Form.Field kind="addons">
                  <Form.Control>
                    <Form.Input
                      type="text"
                      value="support@teamtim.fr"
                      textColor="primary"
                      textWeight="bold"
                    ></Form.Input>
                  </Form.Control>
                  <Form.Control>
                    <Button color={'primary'} onClick={() => setCopy(true)}>
                      {copy ? (
                        <>
                          <Icon>
                            <CheckIcon />
                          </Icon>
                          <span>Copié</span>
                        </>
                      ) : (
                        <>
                          <Icon>
                            <ClipboardCopyIcon />
                          </Icon>
                          <span>Copier</span>
                        </>
                      )}
                    </Button>
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
          </Box>
        </Container>
      </Section>
    </Layout>
  )
}
